$(document).ready(function() {
    $('.mypopover').popover({
        trigger: "hover"
    });
});

function criaPopover(objID) {
    var $buttonPopover = $(document.getElementById(objID));
    $buttonPopover.popover({
        trigger: "hover"
    });
}

$('[data-toggle="popover"]').popover();